<script setup lang="ts">
import { computed } from 'vue'
import { can } from './can'

const props = defineProps<{
  permission: string
}>()

const allowed = computed(() => can(props.permission))
</script>

<template>
  <slot v-if="allowed" />
  <slot v-else name="fallback" />
</template>